import { render, staticRenderFns } from "./trainingModulePageDashboardSingle11.vue?vue&type=template&id=180d9f98&scoped=true&"
import script from "./trainingModulePageDashboardSingle11.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageDashboardSingle11.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageDashboardSingle11.vue?vue&type=style&index=0&id=180d9f98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180d9f98",
  null
  
)

export default component.exports